import './App.css';
import {Recorder} from "./components/WebRTCAudioStreamV2.js"
import MainPage from "./components/MainPage.jsx"
import {SignIn} from "./components/SignInOrUp.js"
import {BrowserRouter as Router,  Routes,  Route,  Navigate} from "react-router-dom";
import { isConnected } from './components/Cookies.js';
import { Userprofile } from './components/UserProfile.js';
import { RecoveryPage } from './components/RecoveryPage.js';
import Payment from './components/stripe/one_time_paiement/Payment.jsx';
import Completion from './components/stripe/one_time_paiement/Completion.jsx';
import {useEffect, useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import SellingPage from './components/SellingPage.js';
import Cancel from './components/stripe/subscription/Cancel.jsx';
import Account from './components/stripe/subscription/Account.jsx';
import Subscribe from './components/stripe/subscription/Subscribe.jsx';
import LandingPage from './pages/LandingPage';
import TOSPage from './pages/TOSPage';
import LegalPage from './pages/LegalPage';
import { LanguageProvider } from './context/LanguageContext';
import { MeetingProvider } from './context/MeetingContext';
import { ColorPickerProvider } from './context/ColorPickerContext';
import { DetailRequestProvider } from './context/DetailRequestContext';
import GlobalColorPickerModal from './components/common/GlobalColorPickerModal';
import DetailRequestModal from './components/common/DetailRequestModal';


// add external javascript file.
export function AddLibrary(urlOfTheLibrary) {
    const script = document.createElement("script");
    script.src = urlOfTheLibrary;
    script.async = true;
    document.body.appendChild(script);
}

function App() {
    const [ stripePromise, setStripePromise ] = useState(null);

    useEffect(() => {
      fetch("/stripe_config")
        .then(async (r) => {
          try {
            if (!r.ok) {
              console.error('Failed to fetch stripe config:', r.status, r.statusText);
              return;
            }
            const text = await r.text();
            if (!text) {
              console.error('Empty response from stripe_config');
              return;
            }
            try {
              const data = JSON.parse(text);
              if (data.publishableKey) {
                setStripePromise(loadStripe(data.publishableKey));
              } else {
                console.error('No publishableKey in stripe config response');
              }
            } catch (parseError) {
              console.error('Failed to parse JSON from stripe_config:', parseError, 'Response was:', text);
            }
          } catch (error) {
            console.error('Error processing stripe config response:', error);
          }
        })
        .catch(error => {
          console.error('Failed to fetch stripe config:', error);
        });
    }, []);

    let routes;
    
    if (isConnected())
    {
        routes = 
            <Routes>
                <Route exact path="/" element={<MainPage />} />
                <Route path="/:lang?" element={<MainPage />} />

                <Route path="/:lang?/meeting/:dongle/:meetingId" element={<MainPage />} />

                <Route path="/:lang?/meeting/:meetingId" element={<MainPage />} />

                <Route
                    exact
                    path="/:lang?/meeting"
                    element={<MainPage />}
                />
                
                <Route
                    path="/:lang?/record"
                    element={<Recorder />}
                />
                

                <Route
                    path="/:lang?/profile"
                    element={<Userprofile />}
                />


                <Route
                    path="/:lang?/recovery_link/:link"
                    element={<RecoveryPage />}
                />

                <Route
                    path="/:lang?/SellingPage"
                    element={<SellingPage />}
                />

                <Route
                    path="/:lang?/paiement/:type"
                    element={<Payment stripePromise={stripePromise} />}
                />

                <Route
                    path="/:lang?/subscribe/:type"
                    element={<Subscribe stripePromise={stripePromise} />}
                />

                <Route 
                    path="/:lang?/completion" 
                    element={<Completion stripePromise={stripePromise} />}
                />

                <Route path="/:lang?/subscribe" element={<Subscribe />} />
                <Route path="/:lang?/account" element={<Account />} />
                <Route path="/:lang?/cancel" element={<Cancel />} />

                {/* If any route mismatches the upper 
        route endpoints then, redirect triggers 
        and redirects app to home component with to="/" */}
                {/* <Redirect to="/" /> */}
                <Route
                    path="*"
                    element={<Navigate to="/" />}
                />
            </Routes>

    }
    else
    {
        routes = 
            <Routes>
                <Route
                    path="/login"
                    element={<SignIn />}
                />
                <Route path="/:lang/login" element={<SignIn />}/>

                <Route
                    path="/signup"
                    element={<SignIn />}
                />
                <Route path="/:lang/signup" element={<SignIn />}/>
                
                <Route
                    path="/meeting"
                    element={<SignIn />}
                />

                <Route
                    path="/recovery_link/:link"
                    element={<RecoveryPage />}
                />

                <Route
                    path="/"
                    element={<LandingPage />}
                />
                
                <Route
                    path="/tos"
                    element={<TOSPage />}
                />
                
                <Route
                    path="/legal"
                    element={<LegalPage />}
                />

                {/* Language-specific routes */}
                <Route path="/en" element={<LandingPage />} />
                <Route path="/fr" element={<LandingPage />} />
                <Route path="/es" element={<LandingPage />} />
                
                <Route path="/en/tos" element={<TOSPage />} />
                <Route path="/fr/tos" element={<TOSPage />} />
                <Route path="/es/tos" element={<TOSPage />} />
                
                <Route path="/en/legal" element={<LegalPage />} />
                <Route path="/fr/legal" element={<LegalPage />} />
                <Route path="/es/legal" element={<LegalPage />} />

                {/* If any route mismatches the upper 
        route endpoints then, redirect triggers 
        and redirects app to home component with to="/" */}
                {/* <Redirect to="/" /> */}
                <Route
                    path="*"
                    element={<Navigate to="/" />}
                />
            </Routes>
    }

  return (
    <LanguageProvider>
      <MeetingProvider>
        <ColorPickerProvider>
          <DetailRequestProvider>
            {/* This is the alias of BrowserRouter i.e. Router */}
            <Router>
                {routes}
            </Router>
            <GlobalColorPickerModal />
            <DetailRequestModal />
          </DetailRequestProvider>
        </ColorPickerProvider>
      </MeetingProvider>
    </LanguageProvider>
  );
}

export default App;
